/**
 * Session Manager - Legacy wrapper around SessionCreationService
 *
 * This file maintains backward compatibility while delegating to the new
 * unified SessionCreationService for consistent behavior.
 */

import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { sessionCreationService } from "@/lib/services/sessionCreationService";

interface CreateAndNavigateOptions {
  router: AppRouterInstance;
  sessionName?: string;
  onSuccess?: (sessionId: string) => void;
  onError?: (error: Error) => void;
  onRefreshSidebarSessions?: () => void;
  // If you need the full session data back, you can add:
  // onSessionDataCreated?: (sessionData: ChatSessionWithMessagesAndBranches) => void;
}

export async function createAndNavigateToNewSession(
  agentId: string,
  options: CreateAndNavigateOptions
): Promise<{ sessionId: string | null; success: boolean }> {
  console.log("[SessionManager] Delegating to SessionCreationService");

  return sessionCreationService.createAndNavigateToNewSession(agentId, {
    ...options,
    source: "sessionManager-legacy",
  });
}
